import { render, staticRenderFns } from "./PlacementStatisticsTable.vue?vue&type=template&id=7269f1e8&scoped=true"
import script from "./PlacementStatisticsTable.vue?vue&type=script&lang=js"
export * from "./PlacementStatisticsTable.vue?vue&type=script&lang=js"
import style0 from "./PlacementStatisticsTable.vue?vue&type=style&index=0&id=7269f1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7269f1e8",
  null
  
)

export default component.exports